// extracted by mini-css-extract-plugin
module.exports = {"next":"Ta_rnW","prev":"oD8c26","disabled":"gON0W5"};